import React from 'react';
import { useStyletron } from 'baseui';
import { IConfigUsage } from '../../../utils/types';
import CodeSnippetViewer from '../../../components/CodeSnippetViewer';
import ServiceChip from '../../../components/ServiceChip';

interface UsagesTabProps {
	usages: IConfigUsage[];
}

const UsagesTab: React.FC<UsagesTabProps> = ({ usages }) => {
	const [css] = useStyletron();

	if (!usages?.length) {
		return <div className={css({ padding: '24px', color: '#666' })}>No code usages found.</div>;
	}

	const grouped = usages.reduce<Record<string, IConfigUsage[]>>((acc, usage) => {
		if (!acc[usage.serviceName]) acc[usage.serviceName] = [];
		acc[usage.serviceName].push(usage);
		return acc;
	}, {});

	return (
		<div className={css({ padding: '16px' })}>
			{Object.entries(grouped).map(([serviceName, serviceUsages]) => (
				<div
					key={serviceName}
					className={css({
						marginBottom: '24px',
						border: '1px solid #E2E2E2',
						borderRadius: '8px',
						padding: '16px'
					})}>
					<div
						className={css({
							display: 'flex',
							alignItems: 'center',
							marginBottom: '12px',
							gap: '8px'
						})}>
						<ServiceChip name={serviceName} />
						<span className={css({ color: '#666', fontSize: '14px' })}>
							{serviceUsages.length} usage{serviceUsages.length > 1 ? 's' : ''}
						</span>
					</div>
					{serviceUsages.map((usage) => (
						<div key={`${usage.filePath}:${usage.lineNumber}`} className={css({ marginBottom: '12px' })}>
							<div
								className={css({
									fontSize: '13px',
									color: '#333',
									marginBottom: '4px',
									display: 'flex',
									alignItems: 'center',
									gap: '8px'
								})}>
								<strong>{usage.functionName}()</strong>
								{usage.affectsDb && (
									<span
										className={css({
											backgroundColor: '#FFF3F0',
											color: '#E11900',
											padding: '2px 8px',
											borderRadius: '4px',
											fontSize: '11px'
										})}>
										DB: {usage.dbCollection}
									</span>
								)}
							</div>
							<CodeSnippetViewer code={usage.codeSnippet} filePath={usage.filePath} lineNumber={usage.lineNumber} />
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default UsagesTab;
